import React from "react";
// COMPONENTS
import SitePageShell from "Components/WebsiteTheme/SitePageShell";
import SiteCtaBand from "Components/WebsiteTheme/SiteCtaBand";
import SiteTestimonial from "Components/WebsiteTheme/SiteTestimonial";
import AboutIntro from "./AboutIntro";
import AboutMission from "./AboutMission";
import OurSubjects from "./OurSubjects";
import AboutFounder from "./AboutFounder";

/**
 * About Us page (Oct 2026 reference design). Shares its header, footer, testimonial, closing band,
 * pillars, subjects and wording with the Home page through Components/WebsiteTheme.
 */
const AboutUs = () => (
	<SitePageShell className="about_us-wrapper">
		<AboutIntro />
		<AboutMission />
		<OurSubjects />
		<AboutFounder />
		<SiteTestimonial className="sm_section sm_section--tight" />
		<SiteCtaBand title="Ready to See Subjects Master in Action?" text="Join the Classroom Pilot or request a demo to see your own content become interactive gaming study guides." />
	</SitePageShell>
);

export default AboutUs;
